<template>
    <div class="progress-container progress-info">
        <span class="progress-badge">Wait  -  Generating PDF</span>
        <div class="progress">
            <div class="progress-bar progress-bar-warning" role="progressbar" :aria-valuenow="progress" aria-valuemin="0"
                 aria-valuemax="100" :style="`width:${progress}%;`">
                <span class="progress-value">{{progress}}%</span>
            </div>
        </div>
    </div>
</template>

<script>
import mqtt from 'mqtt'

export default {
    name: "GeneratePdf",
    props: {
        message: {
            type: Object,
            required:true
        }
    },
    data() {
        return {
            client: {
                connected: false,
            },
            progress: 0
        }
    },
    created() {
        this.createConnection()
    },
    methods: {
        async createConnection() {
            var app  = this;
            this.client = mqtt.connect('wss://test.mosquitto.org:8081/mqtt', this.options)

            this.client.on('connect', () => {
                console.log('Connection succeeded!')
                app.client.publish('whu-converter/docx-pdf', JSON.stringify(app.message))
                this.doSubscribe(app.message.topic)
            })
            this.client.on('error', error => {
                console.log('Connection failed', error)
            })
            this.client.on('message', (topic, message) => {
                if (`${topic}` === app.message.topic) {
                    if (`${message}` === 'success') {
                        app.progress = 100;
                        top.location.href = app.message.url_open
                        setTimeout(function () {
                            window.close()
                        }, 500)
                    }

                    if (`${message}` === 'error') {
                        showMessage('e', 'Error converter pdf');
                    }
                }
                console.log(`Received message ${message} from topic ${topic}`)
            })
        },
        doSubscribe(topic, qos = 0) {
            this.client.subscribe(topic, {qos}, (error, res) => {
                if (error) {
                    console.log('Subscribe to topics error', error)
                    return
                }
                console.log('Subscribe to topics res', res)
            })
        },
    },
    mounted() {
        var app = this;
        setInterval(function (){
            if (app.progress < 98) {
                app.progress += 1
            }else{
                clearInterval()
            }
        }, 200);
    }
}
</script>

<style scoped>

</style>
